export default "__VITE_ASSET__D2Jo8gbw__"